<template>
  <v-card>
    <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
    <v-card-title>
      <span class="display-1">{{ title }}</span>
    </v-card-title>

    <v-card-text class="mt-n7">
      <v-form ref="departmentForm">
        <v-text-field
          data-cy="department-name"
          v-model="department.name"
          label="Avdelningsnamn *"
          placeholder=" "
          :rules="[rules.required]"
          outlined
        ></v-text-field>
        <v-textarea
          data-cy="department-description"
          outlined
          rows="3"
          v-model="department.description"
          label="Beskrivning"
          placeholder=" "
        ></v-textarea>
        <MultiSelect
          ref="multiSelect"
          :list="listEmployments"
          label="Avdelningsadministratörer"
          v-model="department.administratorIds"
        />
        <MultiSelect
          ref="multiSelect"
          :list="listEmployments"
          label="Beställningsgodkännare"
          v-model="department.distanceEducationAdministratorIds"
        />
        <MultiSelect
          ref="multiSelect"
          :list="listEmployments"
          label="Yrkesutbildningsansvariga"
          v-model="department.companyEducationResponsibleIds"
        />
        <MultiSelect
          ref="multiSelect"
          :list="listEmployments"
          label="Handledare"
          v-model="department.instructorIds"
        />
      </v-form>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn data-cy="cancel-department" color="secondary" @click="$emit('close')">
        <v-icon>$sl-cancel</v-icon>Avbryt</v-btn
      >
      <v-btn data-cy="save-department" @click="createDepartment()"> <v-icon>$sl-check</v-icon>Spara</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import MultiSelect from "@/components/common/SelectTypes/MultiSelect";
import { RulesMixin } from "@/components/mixins";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "CreateEditModal",
  mixins: [RulesMixin],
  props: {
    value: {},
  },
  components: {
    MultiSelect,
  },
  data() {
    return {
      listEmployments: [],
      department: {},
      title: "",
    };
  },
  watch: {
    value: {
      handler: function () {
        if (this.value && Object.keys(this.value).length > 0) {
          this.department = this.value;
          this.title = "ÄNDRA AVDELNING";
        } else {
          this.title = "LÄGG TILL AVDELNING";
          this.department = {
            name: "",
            description: "",
            instructorIds: [],
            companyEducationResponsibleIds: [],
            distanceEducationAdministratorIds: [],
            administratorIds: [],
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getEmployees();
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
  },
  methods: {
    getEmployees() {
      API.listCompanyEmployments(this.selectedCompany.id)
        .then((response) => {
          response.data.forEach((el) => {
            this.listEmployments.push({
              id: el.id,
              name: this.$options.filters.fullName(el.employed),
            });
          });
        })
        .catch((error) => {
          console.log("catch Error", error);
        });
    },
    createDepartment() {
      API.createDepartment(this.selectedCompany.id, { data: this.department })
        .then((response) => {
          this.$events.fire("showInfo", "Sparad.");
          this.$refs.departmentForm.reset();
          this.$refs.multiSelect.$refs.form.reset();
          this.$emit("close");
        })
        .catch((error) => {
          console.log("error.msg :>> ", error);
          /* if (error.response && error.response.data && error.response.data.msg) {
            this.$events.fire('showError', error.response.data.msg)
          } */
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
